import {css} from 'styled-components'

export default css`
display: inline-block;
font-family: 'Space Grotesk', sans-serif;
font-size: 12pt;
color: #334b4f;

&.active {
  // Text and icon turn dark blue on hover
  color: #008795;
}

.inlineWrapper {
  display: flex;

  > .shareTrigger {
    display: inline-block;
    width: 54px;
    height: 54px;
    padding: 0;
    margin: 0;
  }

  > .flyout {
    display: inline-block;
    vertical-align: top;

    > .pageTitle {
      margin-bottom: 0.2rem;

      // One line, truncated with '...' at max-width.
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 15rem;
    }

    > .buttons {
      margin-bottom: 0.15rem;
    }
  }
}

&.left {
  .inlineWrapper {
    text-align: right;
    flex-direction: row-reverse;

    > .shareTrigger {
      // Share icon is visually weighted to the right, so tighten the spacing.
      margin-left: -0.3rem;
    }
  }
}
`